import React from 'react';
import { AiOutlineLock } from 'react-icons/ai';
import { ENV } from '../config/env';

const UnauthorizedMessage = () => {
    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <AiOutlineLock style={styles.icon} />
                <h2 style={styles.title}>No tiene ningún rol asignado</h2>
                <p style={styles.message}>
                    Para pedir los permisos necesarios para usar esta aplicación deberá seguir{' '}
                    <a
                        href={ENV.PERMISSIONS_PROCESS_URL || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                    >
                        este proceso
                    </a>.
                </p>
                <p style={styles.footer}>
                    En cualquier otro caso contáctese con el administrador de la aplicación.
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px',
    },
    card: {
        backgroundColor: '#FFFFFF',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '600px',
        width: '100%',
    },
    icon: {
        fontSize: '64px',
        color: '#DC2626',
        marginBottom: '20px',
    },
    title: {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#111827',
        marginBottom: '20px',
    },
    message: {
        fontSize: '18px',
        color: '#374151',
        lineHeight: '1.6',
        marginBottom: '20px',
    },
    link: {
        color: '#00468B',
        textDecoration: 'underline',
        fontWeight: '600',
    },
    footer: {
        fontSize: '14px',
        color: '#6B7280',
        fontStyle: 'italic',
    }
};

export default UnauthorizedMessage;
